import { useEffect, useState, useContext } from 'react';
import { useParticipantEPR } from './ParticipantEPRContext';
import dayjs from 'dayjs';
//import { useSocket } from '../SocketContext';

export default function Header() {
  const [seconds, setSeconds] = useState(0);
  const { eprData, loading, reload } = useParticipantEPR();
  const ptdemos = eprData?.patient || [];
  const scendetails = eprData?.scenarioDetails || [];
  
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (s) => {
    const mins = Math.floor(s / 60).toString().padStart(2, '0');
    const secs = (s % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
  };

function formatDDMMYYYY(iso, { utc = false } = {}) {
  if (!iso) return '';
  return utc
    ? dayjs.utc(iso).format('DD/MM/YYYY')
    : dayjs(iso).format('DD/MM/YYYY');
}

  return (
    <div className="header">
      <div className="header-left">
        <div>Complaint: {scendetails?.complaint}</div>
      </div>
      <div className="header-center">SIM IN SESSION</div>
      <div className="header-right">{formatTime(seconds)}</div>
    </div>
  );
}